import React, { useContext } from 'react';
import styled from 'styled-components';
import { Ringil3H3 } from '@components/ringil3/styles';
import { isNotNullOrUndefined } from '@utils/utils';
import { AuthenticatedUserContext } from '@components/auth/AuthenticatedUser.tsx';
import { FeaturesEnum, PermissionTypesEnum } from '@api/ringil-api.v2.tsx';
import SvgPencil from '@icons/pencil-inverted.svg?react';
import SvgDots from '@icons/more.svg?react';
import RingilButton from '@components/ringil3/Buttons/RingilButton.tsx';
import SecuredArea from '@components/security/SecuredArea';
import { SecuredConfig } from '@components/security/securedDecoration';

interface ComponentProps {
  icon?: JSX.Element;
  title: string;
  // Deprecated: prefer `secured`. Kept optional while call sites migrate to security flags.
  editable?: boolean;
  onEditClick?: () => void;
  onDiscrepancyUpdateClick?: () => void;
  secured?: SecuredConfig;
}

const DiscrepancyEditHeading3: React.FC<ComponentProps> = ({ title, icon, editable, onEditClick = () => {}, onDiscrepancyUpdateClick = () => {}, secured }) => {
  const { loggedUser, hasPermission } = useContext(AuthenticatedUserContext);

  const orderDiscrepancyEnabled = loggedUser?.features?.some(t => t === FeaturesEnum.ORDER_DISCREPANCY);
  const canEditDiscrepancy = hasPermission([PermissionTypesEnum.PERMISSION_ORDER_DISCREPANCY_RW]);

  const editButton = (
    <RingilButton
      mode={'table'}
      icon={<SvgPencil />}
      onClick={() => onEditClick()}
    />
  );

  return (
    <div className="flex items-center gap-2 justify-between mb-3.5">
      <ButtonRow>
        {isNotNullOrUndefined(icon) && icon}
        <Ringil3H3>{title}</Ringil3H3>
      </ButtonRow>
      <ButtonRow>
        {secured ? (
          <SecuredArea {...secured}>{editButton}</SecuredArea>
        ) : (
          <SecuredArea
            id={`discrepancy-edit-heading-${title}`}
            label={title}
            visible={[{ type: 'data', label: 'editable', satisfied: !!editable }]}
          >
            {editButton}
          </SecuredArea>
        )}
        {orderDiscrepancyEnabled && canEditDiscrepancy && <RingilButton
          mode={'table'}
          icon={<SvgDots />}
          onClick={() => onDiscrepancyUpdateClick()}
        />
        }
      </ButtonRow>
    </div>
  );
};

const ButtonRow = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

export default DiscrepancyEditHeading3;
